import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Popup.css';

const PrivacyPolicyPopup = ({ onClose }) => {
  const { t, i18n } = useTranslation();
  const isSlovak = i18n.language === 'sk';

  // Prevent background scrolling when popup is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <div className="popup-header">
          <h2>{t('privacy_policy')}</h2>
          <button className="popup-close" onClick={onClose}>×</button>
        </div>
        <div className="popup-content">
          {isSlovak ? (
            <div className="privacy-policy">
              <h3>Zásady spracúvania a ochrany osobných údajov</h3>
              
              <div className="policy-section">
                <h4>I. Základné ustanovenia</h4>
                <p>V súvislosti so spracúvaním osobných údajov, Vám v zmysle čl. 13 Nariadenia Európskeho parlamentu a Rady EÚ 2016/679 (GDPR) z 27. apríla 2016 o ochrane fyzických osôb pri spracúvaní osobných údajov a voľnom pohybe takýchto údajov, poskytujeme nasledujúce informácie:</p>
                <ol>
                  <li>
                    <p>Prevádzkovateľom osobných údajov je:</p>
                    <p>OZ Tidea Solis<br />
                    Andreja Cházára 909/2, 048 01 Rožňava<br />
                    IČO: 55728472</p>
                  </li>
                  <li>
                    <p>Kontaktné údaje prevádzkovateľa sú: Andreja Cházára 909/2, 048 01 Rožňava,<br />
                    tideasolis@gmail.com</p>
                  </li>
                  <li>
                    <p>Pojmy "Zmluva", "Služba/y" a "Objednávateľ" majú význam aký im pripisujú VOP prevádzkovateľa.</p>
                  </li>
                  <li>
                    <p>Osobnými údajmi sa rozumejú všetky informácie o identifikovanej alebo identifikovateľnej fyzickej osobe; identifikovateľnou fyzickou osobou je fyzická osoba, ktorú možno priamo či nepriamo identifikovať, najmä odkazom na určitý identifikátor, napríklad meno, identifikačné číslo, lokalizačné údaje, sieťový identifikátor alebo odkazom na jeden či viac zvláštnych prvkov fyzickej, fyziologickej, genetickej, psychickej, ekonomickej, kultúrnej alebo spoločenskej identity tejto fyzickej osoby.</p>
                  </li>
                  <li>
                    <p>Prevádzkovateľ nevymenoval zodpovednú osobu pre ochranu osobných údajov.</p>
                  </li>
                </ol>
              </div>

              <div className="policy-section">
                <h4>II. Zdroje a kategórie spracovávaných osobných údajov</h4>
                <ol>
                  <li>
                    <p>Prevádzkovateľ spracúva osobné údaje Objednávateľa, ktoré mu Objednávateľ poskytol alebo osobné údaje, ktoré prevádzkovateľ získal, na základe plnenia objednávky.</p>
                  </li>
                  <li>
                    <p>Prevádzkovateľ spracúva predovšetkým identifikačné a kontaktné údaje Objednávateľa a údaje nevyhnutné pre plnenie Zmluvy, a to najmä: meno, priezvisko, adresa, telefónny kontakt, e-mailová adresa Objednávateľa.</p>
                  </li>
                </ol>
              </div>

              <div className="policy-section">
                <h4>III. Účel spracúvania osobných údajov</h4>
                <ol>
                  <li>
                    <p>Účelom spracúvania osobných údajov je:</p>
                    <ul>
                      <li>uzatváranie a plnenie Zmluvy, ktorých predmetom je dodávka Služieb, dodávaných prevádzkovateľom, pričom táto činnosť zahŕňa predovšetkým, avšak nie len, spracovanie objednávok, vystavovanie daňových dokladov, evidenciu reklamácii a pod.,</li>
                      <li>ponuka služieb a poskytovanie informácií v rámci priameho marketingu,</li>
                      <li>spracúvanie osobných údajov v rámci účtovných dokladov,</li>
                      <li>súdne spory a mimosúdne vymáhanie pohľadávok,</li>
                      <li>vybavovanie reklamácií a sťažností, alebo</li>
                      <li>správa registratúry.</li>
                    </ul>
                  </li>
                </ol>
              </div>

              <div className="policy-section">
                <h4>IV. Právny základ</h4>
                <p>Právnym základom pre spracúvanie osobných údajov je:</p>
                <ol>
                  <li>plnenie zákonných povinností,</li>
                  <li>súhlas dotknutej osoby,</li>
                  <li>plnenie zmluvy, alebo predzmluvných povinností,</li>
                  <li>oprávnený záujem, ktorý sleduje prevádzkovateľ, alebo tretia strana.</li>
                </ol>
              </div>

              <div className="policy-section">
                <h4>V. Doba uchovávania osobných údajov</h4>
                <p>Prevádzkovateľ uchováva osobné údaje:</p>
                <ol>
                  <li>po dobu nevyhnutnú k výkonu práv a povinností vyplývajúcich zo Zmluvy medzi Objednávateľom a prevádzkovateľom a uplatňovanie nárokov z tejto Zmluvy, alebo</li>
                  <li>po dobu, kým je odvolaný súhlas so spracúvaním osobných údajov pre účely marketingu,</li>
                  <li>najdlhšie však po dobu 10 rokov, ak sú osobné údaje spracúvané na základe súhlasu alebo po dobu, akú ukladá zákon.</li>
                </ol>
                <p>Po uplynutí doby uchovávania osobných údajov prevádzkovateľ osobné údaje zlikviduje.</p>
              </div>

              <div className="policy-section">
                <h4>VI. Príjemcovia osobných údajov (subdodávatelia prevádzkovateľa)</h4>
                <p>Príjemcovia osobných údajov sú osoby, ktorým môžu byť osobné údaje poskytnuté a ktoré sa podieľajú na dodávaní služieb, realizácii platieb na základe Zmluvy, osoby zaisťujúce služby prevádzkovania internetového obchodu a ďalšie služby v súvislosti s prevádzkovaním internetového obchodu, osoby zaisťujúce marketingové služby a pod. ako napríklad:</p>
                <ul>
                  <li>Poskytovatelia IT služieb a telekomunikačný operátori</li>
                  <li>Advokátske a právne kancelárie</li>
                  <li>Znalci a súdny znalci</li>
                  <li>Inkasné spoločnosti a exekútori</li>
                  <li>Súdy a orgány činné v trestnom konaní</li>
                  <li>Účtovné kancelárie, audítori a daňový poradcovia</li>
                </ul>
                <p>Medzi spracovateľov osobných údajov patrí</p>
                <ul>
                  <li>ekonomické poradenstvo: md probusiness s.r.o</li>
                </ul>
                <p>Prevádzkovateľ nemá v úmysle odovzdať osobné údaje do tretej krajiny (do krajiny mimo EU) alebo medzinárodnej organizácii.</p>
              </div>

              <div className="policy-section">
                <h4>VII. Práva Objednávateľa</h4>
                <ol>
                  <li>
                    <p>Objednávateľ ako dotknutá osoba má pri spracúvaní osobných údajov právo:</p>
                    <ul>
                      <li>dožadovať sa prístupu k svojim osobným údajom, ako aj právo vedieť na aký účel sú spracúvané, kto sú príjemcovia jeho osobných údajov, aká je doba spracúvania,</li>
                      <li>na opravu osobných údajov, pokiaľ sú jeho osobné údaje nesprávne alebo sa zmenili,</li>
                      <li>na výmaz osobných údajov, pokiaľ sú nesprávne, alebo sú spracúvané nezákonne,</li>
                      <li>právo kedykoľvek odvolať súhlas so spracúvaním osobných údajov bez toho, aby to malo vplyv na zákonnosť spracúvania založeného na súhlase udelenom pred jeho odvolaním,</li>
                      <li>na obmedzenie spracúvania osobných údajov - pokiaľ si Objednávateľ želá, budeme údaje spracúvať iba na najnutnejšie zákonné dôvody, alebo vôbec,</li>
                      <li>na prenosnosť osobných údajov - ak si Objednávateľ želá preniesť ich k inému prevádzkovateľovi, poskytne mu ich prevádzkovateľ v zodpovedajúcom formáte, ak tomu nebudú brániť iné technické, alebo zákonné prekážky.</li>
                      <li>podať sťažnosť dozornému orgánu, ktorým je Úrad pre ochranu osobných údajov Slovenskej republiky, so sídlom Hraničná 12, 820 07 Bratislava 27, Slovenská republika, IČO: 36 064 220, tel. č.: +421 2 3231 3220, https://dataprotection.gov.sk/uoou/</li>
                    </ul>
                  </li>
                </ol>
              </div>

              <div className="policy-section">
                <h4>VIII. Podmienky zabezpečenia osobných údajov</h4>
                <ol>
                  <li>
                    <p>Prevádzkovateľ prehlasuje, že prijal všetky vhodné technické a organizačné opatrenia k ochrane osobných údajov Objednávateľa.</p>
                  </li>
                  <li>
                    <p>Prevádzkovateľ prijal technické opatrenia k zabezpečeniu dátových úložísk a úložísk osobných údajov v listinnej podobe, najmä heslom a firewallom.</p>
                  </li>
                  <li>
                    <p>Prevádzkovateľ prehlasuje, že k osobným údajom majú prístup len ním poverené osoby.</p>
                  </li>
                </ol>
              </div>

              <div className="policy-section">
                <h4>IX. Záverečné ustanovenia</h4>
                <ol>
                  <li>
                    <p>Odoslaním objednávkového formulára Objednávateľ potvrdzuje, že sa oboznámil s týmito podmienkami ochrany osobných údajov Poskytovateľa, a že ich v celom rozsahu prijíma.</p>
                  </li>
                  <li>
                    <p>Prevádzkovateľ je oprávnený tieto podmienky ochrany osobných údajov zmeniť. Novú verziu podmienok ochrany osobných údajov zverejní na svojom webovom sídle. Nové podmienky ochrany osobných údajov nadobúdajú účinnosť voči Objednávateľovi iba s jeho výslovným súhlasom, ktorý súhlas môže poskytnúť pri najbližšom prístupe k Službe po zmene týchto podmienok.</p>
                  </li>
                </ol>
                <p>Tieto podmienky nadobúdajú účinnosť dňa 1.6.2025.</p>
              </div>
            </div>
          ) : (
            <div className="privacy-policy">
              <h3>Privacy Policy</h3>
              <p>This is the English version of the Privacy Policy. Please switch to Slovak language to view the full policy.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPopup; 